/* CLTR prize wheel (sections/cltr-spin.liquid). Settings come from the section's JSON config. */
(function () {
  'use strict';

  var CONFIG_EL = document.querySelector('script[data-cs-config]');
  if (!CONFIG_EL) return;
  var CONFIG = {};
  try { CONFIG = JSON.parse(CONFIG_EL.textContent); } catch (e) { return; }
  var SECTION_ID = CONFIG.sectionId;
  var ROOT = document.getElementById('cs-overlay-' + SECTION_ID);
  if (!ROOT) return;
  var TRIGGER = document.getElementById('cs-trigger-' + SECTION_ID);

  /* Prizes in wheel order. weight = chance in percent (they add up to 100).
     Every code in a pool belongs to the same Shopify discount, so any of them works. */
  /* Free cap and 20% off are capped in total: their Shopify discounts allow 3 uses per code,
     and only 10 / 20 of their codes are handed out here (30 / 60 uses at most). The other
     codes in those discounts are never shown. */
  var POOLS = {"p10":["CLTR10-H42E4","CLTR10-5P2Q7","CLTR10-7HJRQ","CLTR10-VGGAF","CLTR10-TAZSW","CLTR10-HJ7GT","CLTR10-HC97N","CLTR10-NCPFQ","CLTR10-G8QC7","CLTR10-3WHSD","CLTR10-PHAKT","CLTR10-UZHGC","CLTR10-5PRBH","CLTR10-8G3Q7","CLTR10-DJ44M","CLTR10-HGYUT","CLTR10-2FPEZ","CLTR10-4RHHZ","CLTR10-3F9JB","CLTR10-4R42Q","CLTR10-ZMNBX","CLTR10-YB9H4","CLTR10-M8YBK","CLTR10-RTQF3","CLTR10-XM8Q7","CLTR10-RQANX","CLTR10-XG84A","CLTR10-JNDQ8","CLTR10-2FC6G","CLTR10-89ZFQ","CLTR10-N795D","CLTR10-HP6R9","CLTR10-QXWX6","CLTR10-38VWK","CLTR10-P9NUK","CLTR10-DHAUP","CLTR10-U8NRV","CLTR10-P93EP","CLTR10-T3YBP","CLTR10-VNZJG"],"p5":["CLTR5OFF-H2AP8","CLTR5OFF-9M8CH","CLTR5OFF-JCBQP","CLTR5OFF-D6A4J","CLTR5OFF-FHV42","CLTR5OFF-GB8BP","CLTR5OFF-HV439","CLTR5OFF-9P47N","CLTR5OFF-KHXXQ","CLTR5OFF-C27Y9","CLTR5OFF-JET34","CLTR5OFF-SVZ29","CLTR5OFF-7NB72","CLTR5OFF-EJDSE","CLTR5OFF-P68TQ","CLTR5OFF-JN2DN","CLTR5OFF-665CG","CLTR5OFF-TY3W4","CLTR5OFF-EXXWD","CLTR5OFF-GUBXH","CLTR5OFF-96BU4","CLTR5OFF-9M6S8","CLTR5OFF-NSE92","CLTR5OFF-H4PZC","CLTR5OFF-NW27K","CLTR5OFF-7Q6KB","CLTR5OFF-ZYU3C","CLTR5OFF-HSQSN","CLTR5OFF-FZ7JP","CLTR5OFF-CERYX","CLTR5OFF-3A8KY","CLTR5OFF-EDFYN","CLTR5OFF-9KCZX","CLTR5OFF-MZQXT","CLTR5OFF-9F99Q","CLTR5OFF-HFT7N","CLTR5OFF-MS5G8","CLTR5OFF-D5ZEB","CLTR5OFF-M6GRK","CLTR5OFF-SHNEA"],"pship":["CLTRSHIP-WETGM","CLTRSHIP-32KT6","CLTRSHIP-B6BTY","CLTRSHIP-DX2S2","CLTRSHIP-FNHUF","CLTRSHIP-7D63D","CLTRSHIP-EKWCX","CLTRSHIP-C4NC3","CLTRSHIP-F7MH8","CLTRSHIP-EWWFY","CLTRSHIP-FR2RJ","CLTRSHIP-C7NXW","CLTRSHIP-HJH7Y","CLTRSHIP-NSQCH","CLTRSHIP-Z365B","CLTRSHIP-GT84P","CLTRSHIP-6DU4F","CLTRSHIP-DZTPV","CLTRSHIP-E2K7W","CLTRSHIP-TGBMU","CLTRSHIP-6YFME","CLTRSHIP-H7E95","CLTRSHIP-JXAPR","CLTRSHIP-SEEUW","CLTRSHIP-7XYN2","CLTRSHIP-FE6M5","CLTRSHIP-5URCH","CLTRSHIP-4AGGT","CLTRSHIP-TTXK7","CLTRSHIP-SQ2Y9","CLTRSHIP-JP6S2","CLTRSHIP-97PTB","CLTRSHIP-WMQWK","CLTRSHIP-P8M53","CLTRSHIP-D8DJN","CLTRSHIP-H8YJ4","CLTRSHIP-APQY6","CLTRSHIP-3UKMC","CLTRSHIP-J9Y7N","CLTRSHIP-3NGVA"],"p15":["CLTR15-HGCDS","CLTR15-HQHP8","CLTR15-NUVJ4","CLTR15-BQE9H","CLTR15-8HJVN","CLTR15-RG2MA","CLTR15-RNT26","CLTR15-KCJES","CLTR15-HM32M","CLTR15-Q3AJJ","CLTR15-YH2KX","CLTR15-BQAJN","CLTR15-P5H7Z","CLTR15-MDCZZ","CLTR15-RXUPH","CLTR15-VCVWN","CLTR15-YSFNV","CLTR15-DX3BZ","CLTR15-4RVDQ","CLTR15-GPR2N","CLTR15-E5YTX","CLTR15-HVW7V","CLTR15-53VN8","CLTR15-DZK3S","CLTR15-5HAAD","CLTR15-Q2ADQ","CLTR15-MWTSK","CLTR15-NFM6G","CLTR15-KVDZZ","CLTR15-RJ96R","CLTR15-BJ4MT","CLTR15-KE87A","CLTR15-HJMV8","CLTR15-EKHU2","CLTR15-SCUP3","CLTR15-KZSRF","CLTR15-9ENWS","CLTR15-KHHDG","CLTR15-HE6ZR","CLTR15-AR24N"],"p20":["CLTR20-KU9B2","CLTR20-ABEHW","CLTR20-5QWRR","CLTR20-3UQUS","CLTR20-J9H47","CLTR20-DC6HK","CLTR20-VR548","CLTR20-UVWQN","CLTR20-V6BXC","CLTR20-598BW","CLTR20-DBXBF","CLTR20-86JCE","CLTR20-J5U62","CLTR20-7D2XG","CLTR20-F3QXP","CLTR20-YKHSF","CLTR20-JVHY4","CLTR20-HCB87","CLTR20-QHUK8","CLTR20-PHEP5"],"pcap":["CLTRCAP-RYB2U","CLTRCAP-YBC2K","CLTRCAP-U2M74","CLTRCAP-AKA63","CLTRCAP-CBJSA","CLTRCAP-4DJEN","CLTRCAP-FUXDB","CLTRCAP-2R7B9","CLTRCAP-SKSNN","CLTRCAP-ZJ8JE"]};
  var PRIZES = [
    { key: 'p10',   label: '10% OFF',       weight: 50, solid: '10% off',  outline: 'Your order.',  msg: '10% off everything in your basket.' },
    { key: 'pcap',  label: 'FREE CAP',      weight: 1,  solid: 'A free',   outline: 'CLTR cap.',    msg: '£30 off, so any CLTR cap is on us. Delivery is charged as normal.' },
    { key: 'p5',    label: '£5 OFF £50',    weight: 32, solid: '£5 off',   outline: 'Orders £50+.', msg: '£5 off when you spend £50 or more. Two caps gets you there.' },
    { key: 'p20',   label: '20% OFF',       weight: 2,  solid: '20% off',  outline: 'Your order.',  msg: '20% off everything in your basket. Big spin.' },
    { key: 'pship', label: 'FREE DELIVERY', weight: 10, solid: 'Free UK',  outline: 'Delivery.',    msg: 'Free standard UK delivery on your order.' },
    { key: 'p15',   label: '15% OFF',       weight: 5,  solid: '15% off',  outline: 'Your order.',  msg: '15% off everything in your basket.' }
  ];

  var STORE_KEY = 'cltr-wheel-result';
  var DISMISS_KEY = 'cltr-wheel-dismissed';
  var SESSION_KEY = 'cltr-wheel-shown';
  /* The prize is picked before the sign-up is sent and kept here while Shopify saves the
     customer (the page reloads once). It's only spun once Shopify confirms the sign-up. */
  var PENDING_KEY = 'cltr-wheel-pending';
  var PENDING_MAX_AGE = 30 * 60 * 1000;
  var AUTO_DESKTOP_MS = (Number(CONFIG.delayDesktop) || 8) * 1000;
  var AUTO_MOBILE_MS = (Number(CONFIG.delayMobile) || 15) * 1000;
  var AUTO_SHOW = CONFIG.autoShow === true;
  var IS_CART = CONFIG.template === 'cart';
  var DESIGN_MODE = CONFIG.designMode === true;
  var SHOP_URL = CONFIG.shopUrl || '/collections/caps';

  var N = PRIZES.length;
  var ARC = (2 * Math.PI) / N;
  var rot = 0;
  var spinEnd = 0;
  var spinning = false;
  var result = null; /* { k: prize key, c: code } */

  var canvas = ROOT.querySelector('.cs-wheel');
  var hub = ROOT.querySelector('.cs-hub');
  var form = ROOT.querySelector('.cs-form');
  var nameEl = ROOT.querySelector('[data-cs-name]');
  var emailEl = ROOT.querySelector('[data-cs-email]');
  var errorEl = ROOT.querySelector('[data-cs-error]');
  var spinBtn = ROOT.querySelector('[data-cs-spin]');
  var tagsEl = ROOT.querySelector('[data-cs-tags]');
  var lastFocus = null;
  var addedLock = false;
  var captchaWired = false;
  var spinLabelEl = ROOT.querySelector('[data-cs-spin-label]') || spinBtn;
  var spinLabel = spinLabelEl ? spinLabelEl.textContent : '';

  function store(key, value) {
    try {
      if (value === null) localStorage.removeItem(key);
      else localStorage.setItem(key, value);
    } catch (e) {}
  }

  function read(key) {
    try { return localStorage.getItem(key); } catch (e) { return null; }
  }

  /* Pending spin: sessionStorage first (this tab only), localStorage if that's blocked */
  function savePending(obj) {
    var json = JSON.stringify(obj);
    try { sessionStorage.setItem(PENDING_KEY, json); return; } catch (e) {}
    store(PENDING_KEY, json);
  }

  function readPending() {
    var raw = null;
    try { raw = sessionStorage.getItem(PENDING_KEY); } catch (e) {}
    if (!raw) raw = read(PENDING_KEY);
    if (!raw) return null;
    try {
      var obj = JSON.parse(raw);
      if (obj && prizeByKey(obj.k) > -1 && obj.c && Date.now() - (obj.t || 0) < PENDING_MAX_AGE) return obj;
    } catch (e) {}
    clearPending();
    return null;
  }

  function clearPending() {
    try { sessionStorage.removeItem(PENDING_KEY); } catch (e) {}
    store(PENDING_KEY, null);
  }

  function prizeByKey(k) {
    for (var i = 0; i < N; i++) if (PRIZES[i].key === k) return i;
    return -1;
  }

  /* A previous spin on this device: show the same prize and code again, no second spin */
  (function restore() {
    var saved = read(STORE_KEY);
    if (!saved) return;
    try {
      var obj = JSON.parse(saved);
      if (obj && prizeByKey(obj.k) > -1 && obj.c) result = obj;
    } catch (e) {}
  })();

  /* ── drawing ── */
  function cssVar(name) {
    return getComputedStyle(ROOT).getPropertyValue(name).trim();
  }

  function sizeCanvas() {
    var css = canvas.getBoundingClientRect().width || 290;
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var px = Math.round(css * dpr);
    if (canvas.width !== px) {
      canvas.width = px;
      canvas.height = px;
    }
  }

  /* angle: the wheel's rotation now. orient: the rotation the labels are laid out for.
     Labels on the left half are turned the other way so they always read upright where
     the wheel stops (during a spin, orient is the final resting angle). */
  function draw(angle, highlight, orient) {
    if (!canvas) return;
    var ctx = canvas.getContext('2d');
    if (!ctx) return;
    if (orient === undefined) orient = angle;
    var W = canvas.width;
    var c = W / 2;
    var rimW = Math.max(2, W * 0.011);
    var r = c - rimW / 2 - 1;
    var segA = cssVar('--cs-seg-a');
    var segB = cssVar('--cs-seg-b');
    var rim = cssVar('--cs-rim');
    var text = cssVar('--cs-ink-bright');
    var hair = cssVar('--cs-hair-strong');
    var hiText = cssVar('--cs-panel');
    var font = "px 'Exo 2', 'Arial Black', sans-serif";
    var i;

    ctx.setTransform(1, 0, 0, 1, 0, 0);
    ctx.clearRect(0, 0, W, W);

    /* slices and dividers */
    for (i = 0; i < N; i++) {
      var sa = angle + i * ARC - Math.PI / 2;
      ctx.beginPath();
      ctx.moveTo(c, c);
      ctx.arc(c, c, r, sa, sa + ARC);
      ctx.closePath();
      ctx.fillStyle = i === highlight ? rim : (i % 2 ? segB : segA);
      ctx.fill();

      ctx.beginPath();
      ctx.moveTo(c, c);
      ctx.lineTo(c + Math.cos(sa) * r, c + Math.sin(sa) * r);
      ctx.strokeStyle = hair;
      ctx.lineWidth = Math.max(1, W * 0.003);
      ctx.stroke();
    }

    /* labels, from the rim towards the hub */
    var outer = r - W * 0.042;
    var maxW = outer - W * 0.148;
    for (i = 0; i < N; i++) {
      var mid = angle + i * ARC - Math.PI / 2 + ARC / 2;
      var flip = Math.cos(orient + i * ARC - Math.PI / 2 + ARC / 2) < -0.0001;
      var fs = Math.round(W * 0.047);
      var label = PRIZES[i].label;
      ctx.save();
      ctx.translate(c, c);
      ctx.rotate(flip ? mid + Math.PI : mid);
      ctx.textBaseline = 'middle';
      ctx.textAlign = flip ? 'left' : 'right';
      ctx.font = 'italic 900 ' + fs + font;
      while (ctx.measureText(label).width > maxW && fs > 8) {
        fs -= 1;
        ctx.font = 'italic 900 ' + fs + font;
      }
      ctx.fillStyle = i === highlight ? hiText : text;
      ctx.fillText(label, flip ? -outer : outer, 0);
      ctx.restore();
    }

    /* rim, with a tick at each divider */
    ctx.beginPath();
    ctx.arc(c, c, r, 0, 2 * Math.PI);
    ctx.strokeStyle = rim;
    ctx.lineWidth = rimW;
    ctx.stroke();

    for (i = 0; i < N; i++) {
      var ta = angle + i * ARC - Math.PI / 2;
      ctx.beginPath();
      ctx.moveTo(c + Math.cos(ta) * r, c + Math.sin(ta) * r);
      ctx.lineTo(c + Math.cos(ta) * (r - W * 0.035), c + Math.sin(ta) * (r - W * 0.035));
      ctx.strokeStyle = rim;
      ctx.lineWidth = Math.max(1.5, W * 0.006);
      ctx.stroke();
    }
  }

  function redraw() {
    sizeCanvas();
    draw(rot, result && !spinning ? prizeByKey(result.k) : -1, spinning ? spinEnd : rot);
  }

  /* ── odds ── */
  function pick() {
    var total = 0;
    PRIZES.forEach(function (p) { total += p.weight; });
    var x = Math.random() * total;
    for (var i = 0; i < N; i++) {
      x -= PRIZES[i].weight;
      if (x < 0) return i;
    }
    return 0;
  }

  function codeFor(key) {
    var pool = POOLS[key] || [];
    return pool[Math.floor(Math.random() * pool.length)] || '';
  }

  /* ── sign-up ──
     Shopify's own customer form, submitted the normal way so the store's spam check
     (hCaptcha) runs. Shopify saves the customer and reloads the page with
     ?customer_posted=true; the wheel then spins to the prize picked before sending. */
  function wireCaptcha() {
    if (captchaWired || !form || DESIGN_MODE) return;
    captchaWired = true;
    try {
      if (window.Shopify && window.Shopify.captcha && window.Shopify.captcha.protect) window.Shopify.captcha.protect(form);
    } catch (e) {}
  }

  function setBusy(on) {
    if (!spinBtn) return;
    spinBtn.classList.toggle('is-busy', on);
    spinBtn.setAttribute('aria-busy', on ? 'true' : 'false');
    if (spinLabelEl) spinLabelEl.textContent = on ? 'Saving your spin…' : spinLabel;
  }

  function cleanUrl() {
    try {
      var p = new URLSearchParams(location.search);
      p.delete('customer_posted');
      var qs = p.toString();
      history.replaceState(history.state, '', location.pathname + (qs ? '?' + qs : ''));
    } catch (e) {}
  }

  function isEmail(v) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v);
  }

  function easeOut(t) {
    return 1 - Math.pow(1 - t, 4);
  }

  function onSubmit(e) {
    if (spinning || result) {
      e.preventDefault();
      return;
    }

    var name = nameEl ? nameEl.value.trim() : '';
    var email = emailEl ? emailEl.value.trim() : '';
    if (nameEl) nameEl.removeAttribute('aria-invalid');
    if (emailEl) emailEl.removeAttribute('aria-invalid');
    if (!name || !isEmail(email)) {
      e.preventDefault();
      if (!name && nameEl) nameEl.setAttribute('aria-invalid', 'true');
      if (!isEmail(email) && emailEl) emailEl.setAttribute('aria-invalid', 'true');
      if (errorEl) errorEl.textContent = !name ? 'Add your first name and email to spin.' : "That email doesn't look right.";
      return;
    }
    if (errorEl) errorEl.textContent = '';

    /* Keep a prize already picked on this visit (a double click, or a second try after
       Shopify's spam check) so the result can't be re-rolled. */
    var pending = readPending();
    if (!pending) {
      var prize = PRIZES[pick()];
      pending = { k: prize.key, c: codeFor(prize.key), t: Date.now() };
    }
    pending.n = name;
    /* wheel-code-… carries the exact code won, so the prize email can show the same code */
    if (tagsEl) tagsEl.value = 'newsletter,prize-wheel,wheel-' + pending.k + ',wheel-code-' + pending.c;

    if (DESIGN_MODE) {
      /* theme editor: show the spin without creating a customer */
      e.preventDefault();
      startSpin(pending, false);
      return;
    }

    savePending(pending);
    setBusy(true);
    /* No preventDefault: the form posts to Shopify, after the spam check if it runs. */
  }

  function startSpin(p, save) {
    result = { k: p.k, c: p.c, n: p.n };
    if (save) store(STORE_KEY, JSON.stringify({ k: p.k, c: p.c }));
    if (nameEl) nameEl.readOnly = true;
    if (emailEl) emailEl.readOnly = true;
    if (spinBtn) spinBtn.disabled = true;
    runSpin(prizeByKey(p.k));
  }

  function runSpin(won) {
    spinning = true;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var duration = reduce ? 900 : 5200;
    var turns = reduce ? 1 : 6 + Math.floor(Math.random() * 3);
    /* land somewhere inside the winning slice, not always dead centre */
    var jitter = (Math.random() - 0.5) * ARC * 0.6;
    var target = -(won * ARC + ARC / 2 + jitter);
    var current = ((rot % (2 * Math.PI)) + 2 * Math.PI) % (2 * Math.PI);
    var delta = ((target - current) % (2 * Math.PI) + 2 * Math.PI) % (2 * Math.PI);
    var start = rot;
    var total = turns * 2 * Math.PI + delta;
    var t0 = null;
    var lastSeg = -1;
    spinEnd = start + total;

    function frame(ts) {
      if (t0 === null) t0 = ts;
      var p = Math.min((ts - t0) / duration, 1);
      rot = start + total * easeOut(p);
      draw(rot, -1, spinEnd);
      var seg = Math.floor(((rot % (2 * Math.PI)) + 2 * Math.PI) / ARC) % N;
      if (seg !== lastSeg && hub) {
        lastSeg = seg;
        hub.classList.add('is-tick');
        setTimeout(function () { hub.classList.remove('is-tick'); }, 60);
      }
      if (p < 1) {
        requestAnimationFrame(frame);
        return;
      }
      spinning = false;
      draw(rot, won, rot);
      setTimeout(function () { showResult(true); }, reduce ? 200 : 650);
    }
    requestAnimationFrame(frame);
  }

  /* ── result ── */
  function showResult(celebrate) {
    if (!result) return;
    var prize = PRIZES[prizeByKey(result.k)];
    ROOT.querySelector('[data-cs-result-solid]').textContent = prize.solid;
    ROOT.querySelector('[data-cs-result-outline]').textContent = prize.outline;
    ROOT.querySelector('[data-cs-result-eyebrow]').textContent = result.n ? 'Nice one, ' + result.n : 'You won';
    ROOT.querySelector('[data-cs-result-msg]').textContent = prize.msg;
    ROOT.querySelector('[data-cs-code]').textContent = result.c;
    var shop = ROOT.querySelector('[data-cs-shop]');
    if (shop) shop.href = '/discount/' + encodeURIComponent(result.c) + '?redirect=' + encodeURIComponent(SHOP_URL);
    var label = document.querySelector('#cs-trigger-' + SECTION_ID + ' [data-cs-trigger-label]');
    if (label) label.textContent = 'Your code';
    showScreen('result');
    if (celebrate) {
      confetti();
      var copy = ROOT.querySelector('[data-cs-copy]');
      if (copy && !ROOT.hidden) copy.focus({ preventScroll: true });
      /* phones: the code sits under the wheel, so bring it into view */
      var card = ROOT.querySelector('.cs-code');
      if (card && window.matchMedia && window.matchMedia('(max-width: 749px)').matches) {
        try { card.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); } catch (e) {}
      }
    }
  }

  /* 'spin' shows the headline and form; 'result' swaps in the prize and code */
  function showScreen(name) {
    ROOT.classList.toggle('is-result', name === 'result');
  }

  function confetti() {
    var wrap = ROOT.querySelector('[data-cs-confetti]');
    if (!wrap || (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)) return;
    wrap.innerHTML = '';
    var colours = [cssVar('--cs-ink-bright'), cssVar('--cs-ink'), cssVar('--cs-ink-label'), cssVar('--cs-hair-strong')];
    for (var i = 0; i < 48; i++) {
      var bit = document.createElement('i');
      var size = 4 + Math.random() * 6;
      bit.style.cssText =
        'left:' + (10 + Math.random() * 80) + '%;width:' + size + 'px;height:' + size * (Math.random() > 0.5 ? 1 : 2) + 'px;' +
        'background:' + colours[i % colours.length] + ';--x:' + Math.round((Math.random() - 0.5) * 160) + 'px;' +
        '--r:' + Math.round(180 + Math.random() * 300) + 'deg;--d:' + (0.9 + Math.random() * 0.9).toFixed(2) + 's;--w:' + (i * 0.02).toFixed(2) + 's';
      wrap.appendChild(bit);
    }
  }

  function copyCode(e) {
    var btn = e.currentTarget;
    var text = result ? result.c : '';
    function done() {
      btn.textContent = 'Copied';
      setTimeout(function () { btn.textContent = 'Copy'; }, 2000);
    }
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(done, function () {});
    } else {
      var ta = document.createElement('textarea');
      ta.value = text;
      ta.style.cssText = 'position:fixed;opacity:0';
      document.body.appendChild(ta);
      ta.select();
      try { document.execCommand('copy'); done(); } catch (err) {}
      ta.remove();
    }
  }

  /* ── open / close ── */
  function open() {
    if (!ROOT.hidden) return;
    lastFocus = document.activeElement;
    ROOT.hidden = false;
    if (!document.documentElement.hasAttribute('scroll-lock')) {
      document.documentElement.setAttribute('scroll-lock', '');
      addedLock = true;
    }
    if (result && !spinning) showResult(false);
    else showScreen('spin');
    wireCaptcha();
    redraw();
    setTimeout(function () {
      var first = ROOT.querySelector(result ? '[data-cs-copy]' : '[data-cs-name]');
      if (first) first.focus({ preventScroll: true });
    }, 60);
    try { sessionStorage.setItem(SESSION_KEY, '1'); } catch (e) {}
  }

  function close() {
    if (ROOT.hidden) return;
    ROOT.hidden = true;
    if (addedLock) {
      document.documentElement.removeAttribute('scroll-lock');
      addedLock = false;
    }
    if (!result) store(DISMISS_KEY, String(Date.now()));
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  window['cltrWheelOpen_' + SECTION_ID] = open;

  ROOT.querySelectorAll('[data-cs-close]').forEach(function (el) { el.addEventListener('click', close); });
  if (form) form.addEventListener('submit', onSubmit);
  var copyBtn = ROOT.querySelector('[data-cs-copy]');
  if (copyBtn) copyBtn.addEventListener('click', copyCode);

  document.addEventListener('keydown', function (e) {
    if (ROOT.hidden) return;
    if (e.key === 'Escape') close();
    if (e.key === 'Tab') {
      var f = Array.prototype.filter.call(
        ROOT.querySelectorAll('button, a[href], input:not([type=hidden])'),
        function (el) { return !el.disabled && el.offsetParent !== null; }
      );
      if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    }
  });

  if (TRIGGER) {
    var openBtn = TRIGGER.querySelector('[data-cs-open]');
    var lip = TRIGGER.querySelector('[data-cs-lip]');
    if (openBtn) openBtn.addEventListener('click', open);
    if (lip) lip.addEventListener('click', function () {
      var tucked = TRIGGER.classList.toggle('is-tucked');
      lip.setAttribute('aria-expanded', String(!tucked));
    });
    if (result) {
      var lbl = TRIGGER.querySelector('[data-cs-trigger-label]');
      if (lbl) lbl.textContent = 'Your code';
    }
  }

  /* redraw when the header's light/dark switch changes, or the window resizes */
  new MutationObserver(function () { if (!ROOT.hidden) redraw(); })
    .observe(document.documentElement, { attributes: true, attributeFilter: ['data-theme'] });
  window.addEventListener('resize', function () { if (!ROOT.hidden) redraw(); });
  if (document.fonts && document.fonts.load) {
    document.fonts.load("italic 900 16px 'Exo 2'").then(function () { if (!ROOT.hidden) redraw(); }, function () {});
  }

  /* theme editor: open while the section is selected */
  document.addEventListener('shopify:section:select', function (e) { if (e.detail && e.detail.sectionId === SECTION_ID) open(); });
  document.addEventListener('shopify:section:deselect', function (e) { if (e.detail && e.detail.sectionId === SECTION_ID) close(); });

  /* ── back from Shopify after the sign-up ──
     ?customer_posted=true means Shopify saved the customer: spin to the prize picked
     before sending. A form error means it didn't: show the form again, same prize kept. */
  var resumed = false;
  var pendingSpin = !result && !DESIGN_MODE ? readPending() : null;
  if (pendingSpin) {
    var posted = false;
    try { posted = new URLSearchParams(location.search).get('customer_posted') === 'true'; } catch (e) {}
    var serverError = ROOT.querySelector('[data-cs-server-error]');
    if (serverError) {
      resumed = true;
      open();
      if (nameEl && pendingSpin.n) nameEl.value = pendingSpin.n;
      if (emailEl) emailEl.setAttribute('aria-invalid', 'true');
      if (errorEl) errorEl.textContent = "We couldn't save that email. Check it and try again.";
    } else if (posted) {
      resumed = true;
      clearPending();
      cleanUrl();
      var confirmed = ROOT.querySelector('[data-cs-confirmed]');
      if (confirmed) confirmed.textContent = "You're in, " + pendingSpin.n + '. Spinning…';
      ROOT.classList.add('is-confirmed');
      open();
      setTimeout(function () { startSpin(pendingSpin, true); }, 500);
    }
  }

  /* Coming back with the browser's Back button (e.g. from the spam check page) */
  window.addEventListener('pageshow', function (e) {
    if (e.persisted && !spinning && !result) setBusy(false);
  });

  /* ── auto-show: once a session, never in social-app browsers, on the cart page,
     after a spin, or for 3 days after someone closes it ── */
  var inApp = /Instagram|FBAN|FBAV|FB_IAB|Messenger|Twitter|LinkedInApp|TikTok|musical_ly|Snapchat/i.test(navigator.userAgent);
  var dismissed = Number(read(DISMISS_KEY) || 0);
  var recentlyDismissed = dismissed && Date.now() - dismissed < 3 * 24 * 60 * 60 * 1000;
  var shownThisSession = false;
  try { shownThisSession = sessionStorage.getItem(SESSION_KEY) === '1'; } catch (e) {}

  if (AUTO_SHOW && !DESIGN_MODE && !resumed && !inApp && !IS_CART && !result && !recentlyDismissed && !shownThisSession) {
    var mobile = window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
    setTimeout(function () {
      if (ROOT.hidden && !document.querySelector('dialog[open]')) open();
    }, Math.max(mobile ? AUTO_MOBILE_MS : AUTO_DESKTOP_MS, 4000));
  }
})();
